import { Card } from '@/components/ui/card';
import { CustomerExamList } from '@/components/examiner/CustomerExamList';
import { useLanguage } from '@/contexts/LanguageContext';

export function ExaminerDashboard() {
  const { t, dir } = useLanguage();

  return (
    <div className="space-y-6 md:space-y-8" dir={dir}>
      <div className="flex flex-col gap-2">
        <h2 className="text-2xl md:text-3xl font-bold tracking-tight">{t('dashboard.examiner.dashboard.title')}</h2>
        <p className="text-sm md:text-base text-muted-foreground">
          {t('dashboard.examiner.dashboard.description')}
        </p>
      </div>

      <Card className="p-6">
        <CustomerExamList />
      </Card>
    </div>
  );
}